import type { RGProduct } from "@raumagarn/formatters";
import { formatAlgoliaProductCard } from ".";

export const fetchAlgoliaProduct = async (
	productId: string,
	env: {
		CENTRA_CHECKOUT_API_URL: string;
		CENTRA_CHECKOUT_API_SECRET: string;
	},
) => {
	try {
		const response = await fetch(`${env.CENTRA_CHECKOUT_API_URL}/products`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${env.CENTRA_CHECKOUT_API_SECRET}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				products: [String(productId)],
				pricelist: "all",
				market: 5,
				relatedProducts: false,
			}),
		});

		if (!response.ok) {
			throw new Error(`Product not found for id "${productId}"`);
		}

		const data = await response.json();

		const product = data.products?.[0];

		return formatAlgoliaProductCard(product as RGProduct);
	} catch (error) {
		console.error(`[Error: fetchAlgoliaProduct]`, error);
		return null;
	}
};

export type AlgoliaProduct = Awaited<ReturnType<typeof fetchAlgoliaProduct>>;
